<template>
  <div class="w-full h-full py-6">
    <div class="bg-gray-50 rounded-2xl p-4">
      <div class="text-lg font-semibold mb-4">Описание курса</div>

      <div class="mb-4 max-w-full">
        <label class="block text-gray-700 text-sm font-medium mb-2">
          Расширенное описание курса
        </label>
        <div class="max-w-full overflow-hidden">
          <UQuillEditor
              ref="quillEditor"
              v-model="content"
              @update:content="onUpdate"
          />
        </div>
      </div>

      <div class="text-sm text-gray-500 mt-4">
        <p class="mb-2">Подсказки по форматированию:</p>
        <ul class="list-disc list-inside space-y-1">
          <li>Используйте панель инструментов для форматирования текста</li>
          <li>Создавайте заголовки, списки, ссылки и выделения</li>
          <li>Добавляйте цитаты для важной информации</li>
          <li>Используйте различные размеры шрифтов</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, defineEmits, ref, watch} from 'vue'
import UQuillEditor from '@/components/ui/UQuillEditor.vue'
// import {usePortalStore} from "@/stores/portalStore";
//
// const portalStore = usePortalStore()

const props = defineProps({
  course: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:course'])

const content = ref(props.course.extendedDescription || '')

// Отслеживание изменений в props
watch(() => props.course.extendedDescription, (newValue) => {
  content.value = newValue || ''
})

const onUpdate = (value) => {
  emit('update:course', {...props.course, extendedDescription: value})
}


</script>

<style scoped>
/* Стили перенесены в компонент UQuillEditor */
</style>
